<template>
    <ModalWindow :title="$t('dashboard.pages.contract.paymentModal.title')"
     :subtitle="$t('dashboard.pages.contract.paymentModal.subtitle')"
     @closeModal="$emit('close')">
        <div class="stebby-group">
            <NoticePayments/>
            <OptionsSelect style="margin-top: 20px;"
             :options="paymentOptions"
             mode="single"
             @selected="item => selectedPayment = item" />
            <InputNotify class="full-width"
             v-if="warning.show && selectedPayment == 'stebby'"
             :icon="warning.icon"
             :text="warning.text" />
            <Transition name="bounce">
                <div class="stebby-group"
                 v-if="selectedPayment == 'stebby'">
                    <h4>{{ $t('dashboard.pages.contract.paymentModal.enter') }}</h4>
                    <input class="stebby-input uppercase"
                     type="text"
                     placeholder="WXDKASZ31S41"
                     v-model="stebbyCode">
                </div>
            </Transition>
            <Transition name="bounce">
                <div class=""
                 v-if="selectedPayment == 'bank'">
                    <p>35FIT OÜ</p>
                    <p>reg N 14520329</p>
                    <p>VAT N EE102088467</p>
                    <p>adr: Gonsiori tn 33,</p>
                    <p>10147, Tallinn</p>
                    <br>
                    <p>info@35fit.com</p>
                    <br>
                    <p>Swedbank</p>
                    <p>IBAN: EE612200221069641946</p>
                    <p>BIC: HABAEE2X</p>
                    <br>
                    <p><b class="details">{{$t('dashboard.pages.contract.paymentModal.paymentDetails')}}</b></p>
                </div>
            </Transition>

            <Transition name="bounce">
                <div class="full_width"
                 v-if="selectedPayment == 'card'">
                    <p class="uppercase bold">{{ $t('dashboard.pages.contract.paymentModal.paymentDetailsTitle') }}:</p>
                    <br>
                    <p class="bold accent">{{ $t('dashboard.pages.contract.paymentModal.orderSummaryTitle') }}:</p>
                    <div class="details_container">
                        <p class="bold">{{getPackageName(this.ticket.ticket_ticket_id)}}</p>
                        <br>
                        <p>{{ $t('dashboard.pages.contract.paymentModal.price') }}: <span class="bold">€{{(this.ticket.debt > 0) ? this.ticket.debt : this.ticket.next_payment_price}}</span></p>
                        <p>{{ $t('dashboard.pages.contract.paymentModal.total') }}: <span class="bold">€{{(this.ticket.debt > 0) ? this.ticket.debt : this.ticket.next_payment_price}}</span></p>
                    </div>
                    <br>
                    <p class="bold accent ">{{$t('dashboard.pages.contract.paymentModal.recipientTitle')}}:</p>
                    <div class="details_container">
                        <p class="bold">35FIT OÜ</p>
                        <br>
                        <p>reg N 14520329</p>
                        <p>adr: Gonsiori tn 33,</p>
                        <p>10147, Tallinn, Estonia</p>
                        <br>
                        <p>+372 5843 5415</p>
                        <p>+372 5819 3357</p>
                        <p>email: info@35fit.com</p>
                    </div>
                    <br>
                    <p class="bold accent">{{$t('dashboard.pages.contract.paymentModal.payerTitle')}}:</p>
                    <div class="details_container">
                        <p class="bold">{{this.ticket.client_surname}} {{this.ticket.client_name}}</p>
                        <br>
                        <p v-if="this.ticket.client_phone1">{{this.ticket.client_phone1}}</p>
                        <p>email: {{this.ticket.client_email1}}</p>
                    </div>
                    <br>
                    <div class="checkbox-wrapper">
                        <div class="checkbox-icon">
                            <label class="checkbox-container">
                                <input type="checkbox"
                                    v-model="agreement">
                                <span class="checkmark"></span>
                            </label>
                        </div>
                        <p>
                            {{$t('dashboard.pages.contract.paymentModal.read')}} <a class="accent" target="_blank" href="https://app.35fit.com/resources/ClubRules.pdf">{{$t('dashboard.pages.contract.paymentModal.clubRules')}}</a>, <a class="accent" target="_blank" href="https://app.35fit.com/resources/client_contract_ET.pdf">{{$t('dashboard.pages.contract.paymentModal.terms')}}</a>, <a class="accent" target="_blank" href="https://app.35fit.com/resources/GDPR.pdf">{{$t('dashboard.pages.contract.paymentModal.privacyPolicy')}}</a>
                            <!-- {{ $t('dashboard.pages.contract.paymentWidget.modal.agreement') }} -->
                        </p>
                    </div>
                    <br>
                    <p class="secure_text">{{$t('dashboard.pages.contract.paymentModal.secureText')}}</p>
                    <div class="cards_wrapper">
                        <img :src="mcSecure" class="card_image_secure"/>
                        <img :src="visaSecure" class="visa_card_secure"/>
                    </div>
                </div>
            </Transition>

            <Transition name="side">
                <MainButton v-if="selectedPayment == 'stebby' || (selectedPayment == 'card' && agreement)"
                 class="marg-top marg-bot"
                 :widthRestrict="true"
                 :text="(selectedPayment == 'stebby') ? $t('dashboard.pages.contract.paymentModal.code') : $t('dashboard.pages.invoices.pay')"
                 @click="pay()" />
            </Transition>
        </div>
    </ModalWindow>
</template>
<script>
import NoticePayments from '@/components/common/NoticePayments.vue';
import OptionsSelect from '../selectors/OptionsSelect.vue';
import InputNotify from '../InputNotify.vue';
import ModalWindow from '../ModalWindow.vue';
import MainButton from '../buttons/MainButton.vue';
import stebby from '@/assets/img/dashboard/stebby.png'
// import paysera from '@/assets/img/dashboard/paysera.svg'
import euro from '@/assets/svg/eurosign.svg'
import xmark from '@/assets/svg/xmark.svg'
import mcSecure from '@/assets/img/mc_secure.png';
import visaSecure from '@/assets/img/visa_secure_symbol.png';

export default {
    name: 'PaymentModal',
    components: {
        NoticePayments,
        OptionsSelect,
        ModalWindow,
        MainButton,
        InputNotify
    },
    props: {
        ticket: {
            type: Object,
            required: true
        }
    },

    watch: {
        stebbyCode() {
            this.stebbyCode = this.stebbyCode.replace(/[^a-zA-Z0-9]/g, '')
            if (this.stebbyCode.length > 12) {
                this.stebbyCode = this.stebbyCode.slice(0, 12)
            }
        }
    },
    methods: {
        getPackageName(ticketId) {
            if (ticketId == 3790903) {
                return 'Start package: Basic Training Zone Start'
            } else if (ticketId == 4387875) {
                return 'Start package: Basic Training Zone Start Plus'
            } else if (ticketId == 3791127) {
                return 'Membership package: Basic'
            } else if (ticketId == 3791099) {
                return 'Membership package: Midday'
            } else if (ticketId == 3791184) {
                return 'Membership package: Connected to results'
            } else if (ticketId == 4388044) {
                return 'Membership package: Smart Stebby'
            } else {
                return 'Package'
            }
        },
        pay() {
            if (this.selectedPayment == 'paysera') {
                this.$emit('pay', { method: this.selectedPayment })
                return
            }
            if (this.selectedPayment == 'card') {
                this.$emit('pay', { method: this.selectedPayment })
                return
            }
            // allow only latin letters and numbers

            if (this.stebbyCode != '' && this.stebbyCode.length == 12) {
                this.$emit('pay', { method: this.selectedPayment, ticket_code: this.stebbyCode })
                this.unlockScroll()
            } else {
                this.warning.show = true
            }
        },
        unlockScroll() {
            const body = document.querySelector('body');
            body.classList.toggle('menu-open');
        }
    },
    data() {
        return {
            agreement: false,
            mcSecure,
            visaSecure,
            warning: {
                show: false,
                icon: xmark,
                text: this.$t('dashboard.pages.contract.paymentModal.warning')
            },
            paymentOptions:
            //  true ?
             [
                {
                    id: 'stebby',
                    name: 'Stebby',
                    shortText: this.$t('dashboard.pages.contract.paymentModal.stebbyText'),
                    icon: stebby
                },
                {
                    id: 'bank',
                    name: 'Bank',
                    shortText: this.$t('dashboard.pages.contract.paymentModal.bankText'),
                    icon: euro
                },
                // {
                //     id: 'paysera',
                //     name: 'Paysera',
                //     shortText: this.$t('dashboard.pages.contract.paymentModal.payseraText'),
                //     icon: paysera
                // },
                {
                    id: 'card',
                    name: 'Mastercard, Visa',
                    shortText: this.$t('dashboard.pages.contract.paymentModal.cardsText'),
                    // shortText: this.$t('dashboard.pages.contract.paymentModal.payseraText'),
                    icon: 'cards'
                },

            ]
            //  : [
            //     {
            //         id: 'stebby',
            //         name: 'Stebby',
            //         shortText: this.$t('dashboard.pages.contract.paymentModal.stebbyText'),
            //         icon: stebby
            //     },
            //     {
            //         id: 'bank',
            //         name: 'Bank',
            //         shortText: this.$t('dashboard.pages.contract.paymentModal.bankText'),
            //         icon: euro
            //     }
            // ]
            ,
            selectedPayment: null,
            stebbyCode: '',
        }

    }
}
</script>
<style>

.checkbox-wrapper {
    display: flex;
}

.checkbox-icon {
    width: 40px
}

.checkbox-container-agree {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12px;
    position: relative;
    padding-left: 35px;
    height: 25px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
}

.cards_wrapper {
    margin-top: 6px;
    display: flex;
    align-items: center;
}

.secure_text {
    color: rgb(94, 94, 94);
    font-size: 16px;
}

.card_image_secure {
    height: 52px;
    margin-right: 12px;
}

.visa_card_secure {
    height: 52px;
}

.full_width {
    width: 100%;
}

.uppercase {
    text-transform: uppercase;
}

.bold {
    font-weight: bold;
}


.details {
    font-size: 17px;
}

.accent {
    color: #5378ff;
}

.details_container {
    width: 100%;
    padding: 20px;
    margin: 12px 0;
    justify-content: center;
    /* font-size: 14px;
    font-weight: 500; */
    border-radius: var(--br);
    border: 1px solid #e9e9eb;
    height: fit-content;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: all 0.2s ease-in-out;
}
.details_container p {
    line-height: 1.5;
}

</style>
